import { render, staticRenderFns } from "./BorrowerDetails.vue?vue&type=template&id=b6444a18&"
import script from "./BorrowerDetails.vue?vue&type=script&lang=js&"
export * from "./BorrowerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports